<template>
	<div class="pointsystem-preview">
    <loading-state :state="state"></loading-state>
    <div class="pointsystem-main" v-if="state.isLoaded()">
      <h2>{{lpointsystem.name}}</h2>
      <p>{{lpointsystem.desc}}</p>
      <div class="pointsystem-content">
      </div>
    </div>
  </div>
</template>
<script>
import { DataState } from '@/state'
import { FantasyPointsystem } from '@/models/fantasy'

export default {
  props: {
    pointsystem: {
      type: Object,
      defult: null
    },
    contestKey: {
      type: String,
      default: null
    }
  },

  data () {
    return {
      lpointsystem: null,
      state: DataState.newNotInit()
    }
  },

  mounted () {
    this.onViewOpenned()
  },

  methods: {
    onViewOpenned () {
      if (this.pointsystem) {
        this.lpointsystem = this.pointsystem
        this.state.changeToLoaded()
        return
      }

      this.state.changeToLoading()
      FantasyPointsystem.fetch(this.contestKey).then((resp) => {
        this.lpointsystem = resp
        this.state.changeToLoaded()
      }).catch((error) => {
        console.error(error)
        this.state.changeToError(error)
      })
    },
  }
}
</script>
